import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import css from './LeadFlowNavbar.module.css';
import { NamedLink, InlineTextButton } from '../../../../components';
import { Link } from 'react-router-dom';
import Icons from '../../../../components/Icons/Icons';
import { getUserType } from '../../../../util/dataExtractors';
import { UserType } from '../../../../util/enums';

const NAV_LINKS = [
  { label: 'Marketplace', href: '/home-designs' },
  { label: 'About', href: '/about' },
  { label: 'FAQ', href: '/faq' },
];

const MenuIcon = ({ open }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    {open ? (
      <path d="M6 6L18 18M6 18L18 6" stroke="white" strokeWidth="2" strokeLinecap="round" />
    ) : (
      <>
        <path d="M4 6H20" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M4 12H20" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M4 18H20" stroke="white" strokeWidth="2" strokeLinecap="round" />
      </>
    )}
  </svg>
);

const LeadFlowNavbar = ({ currentUser, isAuthenticated, onLogout }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const displayName =
    currentUser?.attributes?.profile?.firstName ||
    currentUser?.attributes?.profile?.displayName ||
    'Account';

  const isSelfBuilder = getUserType(currentUser) === UserType.SELF_BUILDER;

  const handleLogout = () => {
    onLogout(history.push);
  };

  return (
    <nav className={`${css.navbar} ${scrolled ? css.navbarScrolled : ''}`}>
      <div className={css.inner}>
        {/* LeadFlow text logo */}
        <Link to="/leadflow" className={css.logoWrap}>
          <span className={css.logoBold}>Lead</span>
          <span className={css.logoLight}>Flow</span>
        </Link>

        {/* Desktop nav links */}
        <div className={css.navLinks}>
          {NAV_LINKS.map(link => (
            <a key={link.label} href={link.href} className={css.navLink}>
              {link.label}
            </a>
          ))}
        </div>

        {/* Auth CTA */}
        <div className={css.ctaWrap}>
          {isAuthenticated ? (
            <div
              className={css.profileMenuWrapper}
              onMouseEnter={() => setProfileMenuOpen(true)}
              onMouseLeave={() => setProfileMenuOpen(false)}
            >
              <button className={css.ctaBtn}>
                <Icons name="signupIcon" />
                <span>{displayName}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9L12 15L18 9" stroke="white" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>

              {profileMenuOpen && (
                <div className={css.dropdownMenu}>
                  <div className={css.dropdownInner}>
                    {!isSelfBuilder && (
                      <NamedLink className={css.dropdownItem} name="ManageListingsPage">
                        My Listings
                      </NamedLink>
                    )}
                    <NamedLink className={css.dropdownItem} name="ProfileSettingsPage">
                      Profile Settings
                    </NamedLink>
                    <InlineTextButton
                      rootClassName={css.dropdownItemLogout}
                      onClick={handleLogout}
                    >
                      Log out
                    </InlineTextButton>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <Link to={{ pathname: '/login', state: { from: '/leadflow' } }} className={css.ctaBtn}>
              <Icons name="signupIcon" />
              <span>Log in</span>
            </Link>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          className={css.hamburger}
          onClick={() => setMobileOpen(prev => !prev)}
          aria-label="Toggle menu"
        >
          <MenuIcon open={mobileOpen} />
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className={css.mobileMenu}>
          {NAV_LINKS.map(link => (
            <a key={link.label} href={link.href} className={css.mobileLink}>
              {link.label}
            </a>
          ))}
          {isAuthenticated ? (
            <>
              <NamedLink className={css.mobileLink} name="ProfileSettingsPage">
                Profile Settings
              </NamedLink>
              <InlineTextButton rootClassName={css.mobileCta} onClick={handleLogout}>
                Log out
              </InlineTextButton>
            </>
          ) : (
            <Link to={{ pathname: '/login', state: { from: '/leadflow' } }} className={css.mobileCta}>
              Log in
            </Link>
          )}
        </div>
      )}
    </nav>
  );
};

export default LeadFlowNavbar;
